{
	"ca": {
		"label_serveis": "Serveis",
		"label_tipologia": "Filtra per tipologia",
		"tipus_refugi": "Tipus refugi",
		"tots": "Totes",
		"selecciona_tipologia": "Selecciona tipologia",
		"tipologies_seleccionades": "Tipologies seleccionades",
		"serveis": {
			"accessibilitat": "Accessible",
			"aigua": "Aigua potable",
			"climatitzacio": "Climatització",
			"area_descans": "Àrea de descans",
			"lavabo": "Lavabos"
		},
		"font": "Font: Departament Interior, Generalitat de Catalunya. <a href=\"https://analisi.transparenciacatalunya.cat/Seguretat/Refugis-clim-tics-dels-municipis-de-Catalunya/9gu7-iwci/about_data\" target=\"_blank\" rel=\"noopener noreferrer\">Dades obertes</a>",
		"tipologia": {
			"administracio_publica": {
				"nom": "Administració pública",
				"opcions": ["Ajuntament", "ajuntament", "Ajuntament / Equipament Administratiu"]
			},
			"equipament_civic_proximitat": {
				"nom": "Equipaments cívics i de proximitat",
				"opcions": [
					"Casal de Gent Gran",
					"Centre Cívic",
					"Equipament cívic",
					"Equipament de proximitat",
					"Equipaments de proximitat",
					"Sala Polivalent",
					"Sala polivalent"
				]
			},
			"centres_educatius": {
				"nom": "Centres educatius",
				"opcions": [
					"Centre educatiu",
					"Escola / Institut",
					"Patis d'Escola",
					"Patis d'Escola Bressol",
					"Universitats"
				]
			},
			"biblioteques": {
				"nom": "Biblioteques",
				"opcions": ["Biblioteca", "Biblioteques"]
			},
			"equipament_cultural": {
				"nom": "Equipaments culturals",
				"opcions": [
					"Entitats culturals",
					"Equipament Cultural (teatre, auditori, museu)",
					"Espai cultural",
					"Ludoteca",
					"Museus"
				]
			},
			"equipament_esportiu": {
				"nom": "Equipaments esportius",
				"opcions": [
					"Complexos esportius",
					"Equipament esportiu",
					"Gimnàs Municipal",
					"Pavelló Esportiu",
					"Piscina",
					"Piscina Coberta",
					"Piscines",
					"Piscines descobertes",
					"Poliesportiu"
				]
			},
			"verd_espai_obert": {
				"nom": "Parcs i espais oberts",
				"opcions": [
					"Parc",
					"Parc AMB",
					"Parc densament arbrat",
					"Parcs i Jardins",
					"Parcs i jardins",
					"Interiors d'Illa",
					"Jocs d'aigua"
				]
			},
			"comercial_firal_mercat": {
				"nom": "Centres comercials, firals i mercats",
				"opcions": ["Centres comercials", "Espai firal", "Mercat", "Mercats"]
			},
			"equipament_sanitari": {
				"nom": "Equipament sanitari",
				"opcions": ["Equipament Sanitari"]
			},
			"centres_culte": {
				"nom": "Centres de culte",
				"opcions": ["Centres de culte"]
			},
			"ambiental_microrefugi": {
				"nom": "Equipament ambiental / microrefugi",
				"opcions": ["Equipaments Ambientals", "_Microrefugis", "_microRefugi"]
			},
			"altres_privat": {
				"nom": "Privat i altres",
				"opcions": ["Altres", "Privat"]
			}
		},
		"mapbox": {
			"FullscreenControl.Enter": "Pantalla completa",
			"FullscreenControl.Exit": "Torna",
			"ScrollZoomBlocker.CmdMessage": "Fes ⌘ + scroll per fer zoom al mapa",
			"ScrollZoomBlocker.CtrlMessage": "Fes ctrl + scroll per fer zoom al mapa"
		}
	},
	"es": {
		"label_serveis": "Servicios",
		"label_tipologia": "Filtrar por tipología",
		"tipus_refugi": "Tipo de refugio",
		"tots": "Todos",
		"selecciona_tipologia": "Selecciona tipología",
		"tipologies_seleccionades": "Tipologías seleccionadas",
		"font": "Fuente: Departamento Interior, Generalitat de Catalunya. <a href=\"https://analisi.transparenciacatalunya.cat/Seguretat/Refugis-clim-tics-dels-municipis-de-Catalunya/9gu7-iwci/about_data\" target=\"_blank\" rel=\"noopener noreferrer\">Dades obertes</a>",
		"serveis": {
			"accessibilitat": "Accesible",
			"aigua": "Agua potable",
			"climatitzacio": "Climatización",
			"area_descans": "Área de descanso",
			"lavabo": "Lavabos"
		},
		"tipologia": {
			"administracio_publica": {
				"nom": "Administración pública",
				"opcions": ["Ayuntamiento", "ayuntamiento", "Ayuntamiento / Equipamiento Administrativo"]
			},
			"equipament_civic_proximitat": {
				"nom": "Equipamientos cívicos y de proximidad",
				"opcions": [
					"Casa de Abuelos",
					"Centro Cívico",
					"Equipamiento cívico",
					"Equipamiento de proximidad",
					"Equipamientos de proximidad",
					"Sala Polivalente",
					"Sala polivalente"
				]
			},
			"centres_educatius": {
				"nom": "Centros educativos",
				"opcions": [
					"Centro educativo",
					"Escuela / Instituto",
					"Patios de Escuela",
					"Patios de Guardería",
					"Universidades"
				]
			},
			"biblioteques": {
				"nom": "Bibliotecas",
				"opcions": ["Biblioteca", "Bibliotecas"]
			},
			"equipament_cultural": {
				"nom": "Equipamientos culturales",
				"opcions": [
					"Entidades culturales",
					"Equipamiento Cultural (teatro, auditorio, museo)",
					"Espacio cultural",
					"Ludoteca",
					"Museos"
				]
			},
			"equipament_esportiu": {
				"nom": "Equipamientos deportivos",
				"opcions": [
					"Complejos deportivos",
					"Equipamiento deportivo",
					"Gimnasio Municipal",
					"Pabellón Deportivo",
					"Piscina",
					"Piscina Cubierta",
					"Piscinas",
					"Piscinas descubiertas",
					"Polideportivo"
				]
			},
			"verd_espai_obert": {
				"nom": "Parques y espacios abiertos",
				"opcions": [
					"Parque",
					"Parque AMB",
					"Parque densamente arbolado",
					"Parques y Jardines",
					"Parques y jardines",
					"Interiores de Manzana",
					"Juegos de agua"
				]
			},
			"comercial_firal_mercat": {
				"nom": "Centros comerciales, espacios feriales y mercados",
				"opcions": ["Centros comerciales", "Espacio ferial", "Mercado", "Mercados"]
			},
			"equipament_sanitari": {
				"nom": "Equipamiento sanitario",
				"opcions": ["Equipamiento Sanitario"]
			},
			"centres_culte": {
				"nom": "Centros de culto",
				"opcions": ["Centros de culto"]
			},
			"ambiental_microrefugi": {
				"nom": "Equipamiento ambiental / microrefugio",
				"opcions": ["Equipamientos Ambientales", "_Microrefugios", "_microRefugio"]
			},
			"altres_privat": {
				"nom": "Privado y otros",
				"opcions": ["Otros", "Privado"]
			}
		},
		"mapbox": {
			"FullscreenControl.Enter": "Pantalla completa",
			"FullscreenControl.Exit": "Vuelve",
			"ScrollZoomBlocker.CmdMessage": "Usa ⌘ + scroll para hacer zoom en el mapa",
			"ScrollZoomBlocker.CtrlMessage": "Usa ctrl + scroll para hacer zoom en el mapa"
		}
	}
}
